module.exports = __webpack_public_path__ + "static/media/p2.10eb6047.jpg";